module.exports = __webpack_public_path__ + "img/img_bg.49b18e12.png";